import { Box } from "@mui/material";
import aboutheroimage from "../../assets/aboutheroimage.png";
import CustomText, { textStyles } from "../../components/CustomText";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

const MobileAppHeroSection = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <Box
      sx={{
        position: "relative",
        backgroundImage: `url(${aboutheroimage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        overflow: "hidden",
        mt:5,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          bgcolor: "rgba(4, 25, 35, 0.65)", // #041923 at 65% opacity
          zIndex: 1,
        }}
      />
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          color: "#fff",
          height: "100%",
          px: 2,
          py: isMobile ? 8 :11,
        }}
      >
        <CustomText
          style={{
            ...textStyles.h1,
            color: "#E7EBF0",
            marginBottom: isMobile ? "0rem" : "1rem",
            marginTop: isMobile ? "0rem" : "0rem",
            fontSize: isMobile ? "40px" : "50px",
          }}
        >
        {t("mobile_main.heading")}
        </CustomText>

        <CustomText
          style={{
            ...textStyles.body2,
            color: "#EFEFEF",
            maxWidth: "1175px",
            margin: "0 auto",
            marginTop: isMobile ? "20px" : "6px",
            fontSize: "24px"
          }}
        >
          {t("mobile_main.description")}
          </CustomText>
      </Box>
    </Box>
  );
};
export default MobileAppHeroSection;
